import React, { useRef, useState, useEffect, useCallback } from 'react';
import { FixedSizeList as List } from 'react-window';
import { useWindowResize } from 'utils/useWindowResize';
import TableRow from './TableRow';

const ITEM_HEIGHT = 36;

const Row = ({
	data,
	index,
	companies,
	spendFormatter,
	onInputChange,
	items,
	onItemChange,
	highlightId,
	wacc,
	itemsType,
	showTopVendors,
}) => {
	return (
		<TableRow
			wacc={wacc}
			data={data[index]}
			companies={companies}
			spendFormatter={spendFormatter}
			onInputChange={onInputChange}
			items={items}
			onItemChange={onItemChange}
			highlightId={highlightId}
			itemsType={itemsType}
			showTopVendors={showTopVendors}
		/>
	);
};

export const VirtualList = ({
	data,
	companies,
	spendFormatter,
	onInputChange,
	headerRef,
	wrapperRef,
	items,
	onItemChange,
	highlightId,
	wacc,
	itemsType,
	showTopVendors,
}) => {
	const listOuterRef = useRef();
	const listRef = useRef();
	const [height, setHeight] = useState(0);
	const [, windowHeight] = useWindowResize();
	const scrollToItem = useCallback(
		() => {
			if (listRef && listRef.current) {
				const index = data.findIndex(item => item.id === highlightId);

				listRef.current.scrollToItem(index, 'center');
			}
		},
		[listRef, highlightId, data]
	);

	useEffect(
		() => {
			if (wrapperRef && wrapperRef.current) {
				setHeight(wrapperRef.current.clientHeight);
			}
		},
		[wrapperRef, windowHeight]
	);

	useEffect(
		() => {
			const headerEl = headerRef.current;
			const listEl = listOuterRef.current;

			if (headerEl && listEl) {
				listEl.addEventListener(
					'scroll',
					e => {
						headerEl.scrollLeft = e.target.scrollLeft;
					},
					{ passive: true }
				);
			}
		},
		[headerRef, listOuterRef]
	);

	useEffect(
		() => {
			if (highlightId) {
				scrollToItem();
			}
		},
		[highlightId, scrollToItem]
	);

	return (
		<List
			ref={listRef}
			outerRef={listOuterRef}
			height={height}
			width="100%"
			itemCount={data.length}
			itemSize={ITEM_HEIGHT}
			itemData={data}
			style={{ overflow: 'auto overlay' }}
		>
			{({ data, index, style }) => (
				<div style={style}>
					<Row
						itemsType={itemsType}
						wacc={wacc}
						data={data}
						index={index}
						companies={companies}
						spendFormatter={spendFormatter}
						onInputChange={onInputChange}
						items={items}
						onItemChange={onItemChange}
						highlightId={highlightId}
						showTopVendors={showTopVendors}
					/>
				</div>
			)}
		</List>
	);
};
